import { render, staticRenderFns } from "./sale-day-sync-details.vue?vue&type=template&id=383bbb44&scoped=true&"
import script from "./sale-day-sync-details.vue?vue&type=script&lang=ts&"
export * from "./sale-day-sync-details.vue?vue&type=script&lang=ts&"
import style0 from "./sale-day-sync-details.vue?vue&type=style&index=0&id=383bbb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383bbb44",
  null
  
)

export default component.exports